export default __webpack_public_path__ + "static/media/cgh-earth.868480e7.svg";